module.exports = __webpack_public_path__ + "f6b78b138e59d4770fbf0ced87cbea5a.svg";